import { createBaseApi } from "./base.service";
import { RESOURCES } from "./resources";

export type ConquistaDesbloqueada = {
  codigo: string;
  categoria: string;
  nivel: number;
  tituloKey: string;
  descricaoKey: string;
  icone: string;
  dataConquista: string;
  celebracaoVista: boolean;
};

export type ConquistaNivelUsuario = {
  codigo: string;
  categoria: string;
  nivel: number;
  meta: number;
  tituloKey: string;
  descricaoKey: string;
  icone: string;
  tipo: string;
  desbloqueada: boolean;
  progressoAtual: number;
  progressoMeta: number;
  dataConquista: string | null;
  celebracaoVista: boolean;
  galeriaTeaser?: boolean;
};

export type ConquistaCategoria = {
  codigo: string;
  itens: ConquistaNivelUsuario[];
};

export type ListarConquistasResponse = {
  categorias: ConquistaCategoria[];
  desbloqueadas?: ConquistaDesbloqueada[];
};

export type GetConquistasArgs = {
  plataforma?: "web" | "mobile";
};

const CONQUISTAS_TAG = { type: RESOURCES.CONQUISTAS, id: "LIST" } as const;

export const conquistasApi = createBaseApi<ConquistaNivelUsuario>(RESOURCES.CONQUISTAS).injectEndpoints({
  endpoints: (build) => ({
    getConquistas: build.query<ListarConquistasResponse, GetConquistasArgs | undefined>({
      query: (args) => ({
        url: "/conquistas",
        method: "GET",
        params: args?.plataforma ? { plataforma: args.plataforma } : undefined,
      }),
      serializeQueryArgs: ({ endpointName, queryArgs }) =>
        `${endpointName}-${queryArgs?.plataforma ?? "all"}`,
      keepUnusedDataFor: 3600,
      providesTags: [CONQUISTAS_TAG],
    }),
    marcarConquistaVista: build.mutation<{ ok: boolean }, { codigo: string; nivel: number }>({
      query: ({ codigo, nivel }) => ({
        url: `/conquistas/${encodeURIComponent(codigo)}/nivel/${nivel}/vista`,
        method: "PATCH",
      }),
      invalidatesTags: [CONQUISTAS_TAG],
    }),
  }),
});

export const { useGetConquistasQuery, useMarcarConquistaVistaMutation } = conquistasApi;
